export class ProjectCountryModel {
    projectId = 0;
    countryId = 0;
    percent = 0;
}
